/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoveringAgentId
 */
export interface CoveringAgentId {
}

/**
 * Check if a given object implements the CoveringAgentId interface.
 */
export function instanceOfCoveringAgentId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CoveringAgentIdFromJSON(json: any): CoveringAgentId {
    return CoveringAgentIdFromJSONTyped(json, false);
}

export function CoveringAgentIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoveringAgentId {
    return json;
}

export function CoveringAgentIdToJSON(value?: CoveringAgentId | null): any {
    return value;
}

